import React from 'react';
import { Formik, Form } from 'formik';
import { Box, Heading } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import * as Yup from 'yup';
import { InputCustom, ButtonCustom } from '../UI';
import AuthLinks from '../authBottomLinks';
import { useAppDispatch, useAppSelector } from '../../../utils/reduxHooks';
import { restorePasswordAction } from '../../../modules/auth/actions';
import { useNavigate } from 'react-router-dom';
import { routes } from '../../../constants/routes';

const link1 = '/signUp';
const link2 = '/signUp';
const linkName1 = 'Нет аккаунта?';
const linkName2 = 'Зарегистрироваться';

const validationSchema = Yup.object().shape({
  password: Yup.string()
    .required('Введите новый пароль')
    .min(6, 'Пароль должен быть не менее 6 символов'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password')], 'Пароли должны совпадать')
    .required('Подтвердите новый пароль'),
});

export const NewPasswordForm: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const phone = useAppSelector(state => state.auth.phone);
  const code = useAppSelector(state => state.auth.code);

  const handleSubmit = async (values: {
    password: string;
    confirmPassword: string;
    username: string;
  }) => {
    try {
      dispatch(
        restorePasswordAction.request({
          phoneNumber: phone,
          code: +code,
          password: values.password,
          passwordSubmit: values.confirmPassword,
        }),
      );
      setTimeout(() => navigate(routes.MAIN), 1000);
    } catch (error) {
      console.error('Error setting new password:', error);
    }
  };

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        height="100vh"
        padding="101px 0 110px"
        w="100%"
        maxW="416px"
      >
        <Formik
          initialValues={{ password: '', confirmPassword: '', username: phone || '' }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ errors, touched, values, handleChange }) => (
            <Form>
              <Heading mb={6} fontSize="28px">
                Создание нового пароля
              </Heading>
              <Box style={{ display: 'none' }}>
                <InputCustom
                  label="Username"
                  name="username"
                  value={values.username}
                  onChange={handleChange}
                  placeholder="Username"
                />
              </Box>
              <InputCustom
                type="password"
                label="Пароль"
                name="password"
                value={values.password}
                onChange={handleChange}
                errorMessage={touched.password && errors.password}
                placeholder="********************"
              />
              <Box mt="10px">
                <InputCustom
                  type="password"
                  label="Повторить пароль"
                  name="confirmPassword"
                  value={values.confirmPassword}
                  onChange={handleChange}
                  errorMessage={touched.confirmPassword && errors.confirmPassword}
                  placeholder="********************"
                />
              </Box>
              <ButtonCustom variant="withBackground" mt={6} w="full" type="submit">
                Изменить пароль
              </ButtonCustom>
            </Form>
          )}
        </Formik>
        <AuthLinks link1Name={linkName1} link1Url={link1} link2Name={linkName2} link2Url={link2} />
      </Box>
    </motion.div>
  );
};
